import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ArrowTopIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 1.84199L1.25981 7.77653C0.971612 8.07449 0.504346 8.07449 0.216147 7.77652C-0.0720515 7.47856 -0.0720488 6.99547 0.216154 6.69751L6.47817 0.223469C6.76637 -0.0744895 7.23363 -0.0744895 7.52183 0.223469L13.7838 6.69751C14.072 6.99547 14.0721 7.47856 13.7839 7.77652C13.4957 8.07449 13.0284 8.07449 12.7402 7.77653L7 1.84199Z"
      fill={fill}
    />
  </svg>
);

export default ArrowTopIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ArrowTopIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 1.84199L1.25981 7.77653C0.971612 8.07449 0.504346 8.07449 0.216147 7.77652C-0.0720515 7.47856 -0.0720488 6.99547 0.216154 6.69751L6.47817 0.223469C6.76637 -0.0744895 7.23363 -0.0744895 7.52183 0.223469L13.7838 6.69751C14.072 6.99547 14.0721 7.47856 13.7839 7.77652C13.4957 8.07449 13.0284 8.07449 12.7402 7.77653L7 1.84199Z"
      fill={fill}
    />
  </svg>
);

export default ArrowTopIcon;
